import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { User } from 'src/app/distribution/user.model';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'sd-content-banner',
    templateUrl: './content-banner.component.html',
    styleUrls: ['./content-banner.component.scss']
})

export class ContentBannerComponent implements OnInit {

    @Input() raiseIssue: any

    adsLoaded: Boolean = false;
    ad: any;

    showAd: Boolean = false;

    constructor(
        public api: ApiService,
        public global: GlobalService,
        public router: Router,
        public user: UserService
    ) {
        // this.advetisement();
    }

    ngOnInit() {
        // console.log(this.raiseIssue)
        this.advetisement();
    }

    advetisement() {
        let issue = this.raiseIssue ? 'issue' : ''
        this.api.advertisement(issue).subscribe(res => {
            // console.log(res);
            this.adsLoaded = true;
            let urt = this.router.url.split('?')[0].split('/')

            if (res.success && res.result.length > 0) {
                res.result.forEach(ad => {
                    let for_pro = ad.for_pro;
                   
                    //alert(this.router.url.indexOf('mydashboard'))
                    if(for_pro == 0 || (for_pro == 1 && this.user.isProMember == 1)){

                    
                    if (ad.adv_display_pages.includes('artist_dashboard') && this.router.url.split('?')[0] == '/mydashboard') {

                            this.ad = ad;
                            this.showAd = true;
                   
                    } else if(ad.adv_display_pages.includes('checkout') && this.router.url.split('?')[0] == '/subscription/checkout' ){
                        this.ad = ad;
                        this.showAd = true;
                    }
                    else if ( ad.adv_display_pages.includes('song_list') && (this.router.url.split('?')[0] == '/songs' || this.router.url.split('?')[0].indexOf('/songs/') !== -1) &&  (urt[1] != 'mydashboard')) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('video_list') && (this.router.url.split('?')[0] == '/video-songs' || this.router.url.split('?')[0].indexOf('/video-songs/') !== -1) ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('opportunity_success') && (urt[1]=='opportunities' && urt[urt.length -1 ] =='success') ) {

                       
                            this.ad = ad;
                            this.showAd = true;
                        
                    } else if ( ad.adv_display_pages.includes('opportunity_detail') && (urt[1]=='opportunities' && urt[2]!='') ) {

                       
                            this.ad = ad;
                            this.showAd = true;
                        
                    } else if ( ad.adv_display_pages.includes('opportunities_list') && this.router.url.split('?')[0] == '/opportunities' ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('upload_tracks') && (this.router.url.split('?')[0] == '/upload/song' || this.router.url.split('?')[0] == '/upload/tracks') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('upload_albums') && (this.router.url.split('?')[0] == '/upload/album' || this.router.url.split('?')[0] == '/upload/tracks') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('upload_videos') && (this.router.url.split('?')[0] == '/upload/video' || this.router.url.split('?')[0] == '/upload/videos' || this.router.url.split('?')[0] == '/upload/tracks') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('my_opportunities_detail') && this.router.url.split('?')[0] == '/mydashboard/opportunities' ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('my_music_detail') && (this.router.url.split('?')[0] == '/mydashboard/songs') && this.router.url.split('?')[1]=== undefined  ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('my_videos') && (this.router.url.split('?')[0] == '/mydashboard/videos') && this.router.url.split('?')[1]=== undefined  ) {
                        this.ad = ad;
                        this.showAd = true;
                    }
                     else if ( ad.adv_display_pages.includes('playlists_list') && (this.router.url.split('?')[0] == '/playlists') ) {
                        this.ad = ad;
                        this.showAd = true;
                    }  else if ( ad.adv_display_pages.includes('tv') && (this.router.url.split('?')[0] == '/songdew-tv') ) {
                         this.ad = ad;
                         this.showAd = true;
                    }  else if ( ad.adv_display_pages.includes('distribute') && (this.router.url.split('?')[0] == '/distribute' || this.router.url.split('?')[0] == '/distribute') ) {
                         this.ad = ad;
                         this.showAd = true;
                    } 
                     else if ( ad.adv_display_pages.includes('my_release') && this.router.url.split('?')[0] == '/distribute/my-releases') {
                        this.ad = ad;
                         this.showAd = true;
                    }
                    else if ( ad.adv_display_pages.includes('artists_list') && this.router.url.split('?')[0] == '/artists') {
                        this.ad = ad;
                         this.showAd = true;
                    } 

                     else if ( ad.adv_display_pages.includes('analytics_detail') && this.router.url.split('?')[0] == '/distribute/analytics') {
                        this.ad = ad;
                         this.showAd = true;
                    }


                    else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[1] !== undefined ) {
                        if(this.router.url.split('?')[1].split('=')[0] == 'tab'){
                            this.ad = ad;
                            this.showAd = true;
                        }
                    }

                    else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
                        this.ad = ad;
                         this.showAd = true;
                    }
                    
                    else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/achievements') {
                        this.ad = ad;
                         this.showAd = true;
                    }else if ( ad.adv_display_pages.includes('revenuereports') && this.router.url.split('?')[0] == '/revenuereports') {
                        this.ad = ad;
                         this.showAd = true;
                    }





                    else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
                        this.ad = ad;
                         this.showAd = true;
                    }else if ( ad.adv_display_pages.includes('pro_perks') && this.router.url.split('?')[0] == '/pro-perks') {
                        this.ad = ad;
                         this.showAd = true;
                    }else if ( ad.adv_display_pages.includes('promote') && this.router.url.split('?')[0] == '/promote') {
                        this.ad = ad;
                         this.showAd = true;
                    }else if(ad.adv_display_pages.includes('dist_succ_single') && this.router.url.split('?')[0] == '/distribute/music/song' ){
                        this.ad = ad;
                        this.showAd = true;
                    }else if(ad.adv_display_pages.includes('achievements_detail') && this.router.url.split('?')[0] == '/mydashboard/achievements' ){
                        this.ad = ad;
                        this.showAd = true;
                    }else if(ad.adv_display_pages.includes('dist_succ_album') && this.router.url.split('?')[0] == '/distribute/music/album' ){
                        this.ad = ad;
                        this.showAd = true;
                    }else if(ad.adv_display_pages.includes('broadcast_video') && this.router.url.split('?')[0] == '/upload/videos' ){
                        this.ad = ad;
                        this.showAd = true;
                    }
                    }else if(for_pro == 2 && this.user.isProMember != 1){

                    
                    if (ad.adv_display_pages.includes('artist_dashboard') && this.router.url.split('?')[0] == '/mydashboard') {

                            this.ad = ad;
                            this.showAd = true;

                    } 
                    else if ( ad.adv_display_pages.includes('song_list') && (this.router.url.split('?')[0] == '/songs' || this.router.url.split('?')[0].indexOf('/songs/') !== -1) &&  (urt[1] != 'mydashboard')) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('video_list') && (this.router.url.split('?')[0] == '/video-songs' || this.router.url.split('?')[0].indexOf('/video-songs/') !== -1) ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('opportunity_success') && (urt[1]=='opportunities' && urt[urt.length -1 ] =='success') ) {

                       
                            this.ad = ad;
                            this.showAd = true;
                        
                    } else if ( ad.adv_display_pages.includes('opportunity_detail') && (urt[1]=='opportunities' && urt[2]!='') ) {

                       
                            this.ad = ad;
                            this.showAd = true;
                        
                    } else if ( ad.adv_display_pages.includes('opportunities_list') && this.router.url.split('?')[0] == '/opportunities' ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('upload_tracks') && (this.router.url.split('?')[0] == '/upload/song' || this.router.url.split('?')[0] == '/upload/tracks') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('upload_albums') && (this.router.url.split('?')[0] == '/upload/album' || this.router.url.split('?')[0] == '/upload/tracks') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('upload_videos') && (this.router.url.split('?')[0] == '/upload/video' || this.router.url.split('?')[0] == '/upload/videos' || this.router.url.split('?')[0] == '/upload/tracks') ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('my_opportunities_detail') && this.router.url.split('?')[0] == '/mydashboard/opportunities' ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('my_music_detail') && (this.router.url.split('?')[0] == '/mydashboard/songs') && this.router.url.split('?')[1]=== undefined  ) {
                        this.ad = ad;
                        this.showAd = true;
                    } else if ( ad.adv_display_pages.includes('my_videos') && (this.router.url.split('?')[0] == '/mydashboard/videos') && this.router.url.split('?')[1]=== undefined  ) {
                        this.ad = ad;
                        this.showAd = true;
                    }
                     else if ( ad.adv_display_pages.includes('playlists_list') && (this.router.url.split('?')[0] == '/playlists') ) {
                        this.ad = ad;
                        this.showAd = true;
                    }  else if ( ad.adv_display_pages.includes('tv') && (this.router.url.split('?')[0] == '/songdew-tv') ) {
                         this.ad = ad;
                         this.showAd = true;
                    }  else if ( ad.adv_display_pages.includes('distribute') && (this.router.url.split('?')[0] == '/distribute' || this.router.url.split('?')[0] == '/distribute') ) {
                         this.ad = ad;
                         this.showAd = true;
                    } 
                     else if ( ad.adv_display_pages.includes('my_release') && this.router.url.split('?')[0] == '/distribute/my-releases') {
                        this.ad = ad;
                         this.showAd = true;
                    }
                    else if ( ad.adv_display_pages.includes('artists_list') && this.router.url.split('?')[0] == '/artists') {
                        this.ad = ad;
                         this.showAd = true;
                    } 

                     else if ( ad.adv_display_pages.includes('analytics_detail') && this.router.url.split('?')[0] == '/distribute/analytics') {
                        this.ad = ad;
                         this.showAd = true;
                    }


                    else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[1] !== undefined ) {
                        if(this.router.url.split('?')[1].split('=')[0] == 'tab'){
                            this.ad = ad;
                            this.showAd = true;
                        }
                    }

                    else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
                        this.ad = ad;
                         this.showAd = true;
                    }
                    
                    else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/achievements') {
                        this.ad = ad;
                         this.showAd = true;
                    }else if ( ad.adv_display_pages.includes('revenuereports') && this.router.url.split('?')[0] == '/revenuereports') {
                        this.ad = ad;
                         this.showAd = true;
                    }





                    else if ( ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.split('?')[0] == '/mydashboard/promote') {
                        this.ad = ad;
                         this.showAd = true;
                    }else if ( ad.adv_display_pages.includes('pro_perks') && this.router.url.split('?')[0] == '/pro-perks') {
                        this.ad = ad;
                         this.showAd = true;
                    }else if ( ad.adv_display_pages.includes('promote') && this.router.url.split('?')[0] == '/promote') {
                        this.ad = ad;
                         this.showAd = true;
                    }else if(ad.adv_display_pages.includes('dist_succ_single') && this.router.url.split('?')[0] == '/distribute/music/song' ){
                        this.ad = ad;
                        this.showAd = true;
                    }else if(ad.adv_display_pages.includes('achievements_detail') && this.router.url.split('?')[0] == '/mydashboard/achievements' ){
                        this.ad = ad;
                        this.showAd = true;
                    }else if(ad.adv_display_pages.includes('dist_succ_album') && this.router.url.split('?')[0] == '/distribute/music/album' ){
                        this.ad = ad;
                        this.showAd = true;
                    }else if(ad.adv_display_pages.includes('broadcast_video') && this.router.url.split('?')[0] == '/upload/videos' ){
                        this.ad = ad;
                        this.showAd = true;
                    }else if(ad.adv_display_pages.includes('checkout') && this.router.url.split('?')[0] == '/subscription/checkout' ){
                        this.ad = ad;
                        this.showAd = true;
                    }
                    }

                   
                });
            


                /*
                } else if ( this.ad.adv_display_pages.includes('tv') && this.router.url.indexOf('songdew-tv') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('artist_dashboard') && this.router.url.indexOf('mydashboard') > -1 ) {
                     this.ad = ad;
                    this.showAd = true;
                   
                } else if ( this.ad.adv_display_pages.includes('playlists_list') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('opportunities_list') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('user_feed') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('artists_list') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('promotions_tab_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('analytics_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('my_opportunities_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('achievements_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } else if ( this.ad.adv_display_pages.includes('my_music_detail') && this.router.url.indexOf('spotlight') > -1 ) {
                    this.showAd = true;
                } */
            }
        },
        (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
                // console.log('Client-side error occured!');
            } else {
                // console.log('Server-side error occured!', err);
            }
        });
    }
}
